<template>
	<div>
		<div
			class="directory-card-wrapper d-flex mb-2"
			v-bind:style="{ paddingTop: customFlag ? '30px' : '12px' }"
		>
			<div v-if="customFlag" :style="{ backgroundColor: customBackgroundColor }" class="tag">
				{{ customFlagName }}
			</div>

			<Avatar class="mr-3 directory-card-wrapper__avatar" :size="52" :avatar="logo" />

			<div class="directory-card-info">
				<div v-if="name" class="directory-card-title">
					{{ name }}
				</div>
				<div v-if="company" class="directory-card-description mt-1">
					{{ company }}
				</div>
				<div v-if="thirdRow" style="margin-top: 2px" class="directory-card-description">
					{{ thirdRow }}
				</div>
				<div v-if="forthRow" class="directory-card-description mt-2">
					{{ forthRow }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'
import ProfileBadge from '@/components/ProfileBadge.vue'

Vue.use(VueScrollTo)

export default {
	name: 'DirectoryCard',
	components: {
		Avatar,
		ProfileBadge,
	},
	props: {
		directory: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		customBackgroundColor() {
			const { custom_flag_color: value } = this.directory || {}
			return value
		},
		customFlag() {
			const { custom_flag: value } = this.directory || {}
			return value
		},
		customFlagName() {
			const { custom_flag_name: value } = this.directory || {}
			return value
		},
		logo() {
			const { directory_logo: logo } = this.directory || {}

			return logo
		},
		company() {
			const { directory_second_row: company } = this.directory || {}

			return company
		},
		name() {
			const { directory_first_row: firstName } = this.directory || {}

			return `${firstName}`
		},
		thirdRow() {
			const { directory_third_row: row } = this.directory || {}

			return row
		},
		forthRow() {
			const { directory_forth_row: row } = this.directory || {}

			return row
		},
	},
}
</script>

<style lang="scss">
.directory-card {
	&-wrapper {
		display: flex;
		position: relative;
		font-family: 'Inter', sans-serif;
		background: #ffffff;
		border: 1px solid rgb(226, 226, 226);
		border-radius: 10px;
		padding: 12px;
		&__avatar {
			border-radius: 8px;
		}
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 12px;
	}

	&-title {
		color: var(--username-category-title);
		font-weight: 700;
		font-size: 16px;
		line-height: 120%;
		letter-spacing: 0;
	}

	&-location {
		display: flex;
		font-weight: 500;
		font-size: 13px;
		line-height: 120%;
		letter-spacing: 0;
		color: var(--location-color) !important;
	}

	&-description {
		color: var(--company-position-large);
		font-weight: 400;
		font-size: 13px;
		line-height: 120%;
		letter-spacing: 0;
		word-break: break-all;
		display: -webkit-box;
	}
}

.location-icon {
	color: var(--accent-color) !important;
}

@media screen and (min-width: 1200px) {
	.directory-card-wrapper {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.directory-card-wrapper {
		max-width: 555px;
	}
}
.tag {
	--wedge: 15px;
	position: absolute;
	top: 0;
	right: 0;
	height: 22px;
	display: flex;
	align-items: center;
	padding: 4px 8px 3px 16px;
	color: #ffffff;
	font: 700 12px/100% 'Inter', sans-serif;
	clip-path: polygon(0 0, 100% 0, 100% 100%, var(--wedge) 100%);
	border-top-right-radius: 8px;
}
</style>
